import React from 'react';

import { useFlowState } from '@betterment/js-runtime';

import WorkflowLayout, { LayoutComponent, Slot, Props as WorkflowLayoutProps } from '../../components/WorkflowLayout';

export interface Props extends Omit<WorkflowLayoutProps, 'progressPercent' | 'handleBackButton'> {
  showProgress?: boolean;
  progressPercent?: WorkflowLayoutProps['progressPercent'];
}

const ConnectedWorkflowLayout: LayoutComponent<Props> = ({
  children,
  progressPercent,
  showProgress = true,
  ...rest
}) => {
  const { progressPercent: _progressPercent, goToPreviousStep, getPreviousStep } = useFlowState();
  progressPercent = progressPercent || _progressPercent;
  const handleBackButton = (event: React.MouseEvent) => {
    event.preventDefault();
    goToPreviousStep();
  };

  return (
    <WorkflowLayout
      progressPercent={showProgress ? progressPercent : undefined}
      handleBackButton={getPreviousStep() ? handleBackButton : undefined}
      {...rest}
    >
      {children}
    </WorkflowLayout>
  );
};

ConnectedWorkflowLayout.Slot = Slot;

export default ConnectedWorkflowLayout;
